<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-end">
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center body"
        >
          <IconWarning />

          <p class="mt-3 font-20 font-weight-bolder text-capitalize">
            {{ action }} {{ name }}?
          </p>

          <p class="gray4 font-14" style="text-align: center;">
            {{ msg }} <span v-if="!isDevicesRoute"> {{ name.toLowerCase() }}?</span> 
          </p>

          <div
            class="mt-4 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-secondary w-100"
              @click="$emit('close')"
            >
              {{$t("no")}}
            </button>

            <button
              :class="buttonClass"
              type="button"
              class="w-100 text-capitalize btn"
              @click="$emit('submit')"
            >
              {{ $t("yes") }}, {{ action }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import IconWarning from "../../components/Iconsvg/IconWarning";
export default {
  name: "DeleteModal",
  components: {
    ModalContainer,
    IconWarning,
  },
  props: {
    show: Boolean,
    name: String,
    msg: {
      type: String,
      default: "Are you sure you want to delete this",
    },
    action: {
      type: String,
      default: "Delete",
    },
    isDevicesRoute: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: 'btn-danger',
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%;
}
.body {
  padding: 50px;
}
@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
  .body {
    padding: 25px;
  }
}
</style>
